import {
    Badge,
    Text,
} from '@mantine/core';
import {PlatformPropertyCard} from '@flexinet/ui-components';

import {HostedZone} from '../types';

// The delegation set. This is the reason the detail page exists as a separate
// fetch: `nameServers` is null on every listHostedZones row and populated only
// by getHostedZone (see services/queries.ts).
const NameServers = ({nameServers}: { nameServers?: string[] | null }) => {

    if (!nameServers || nameServers.length === 0) {
        // Distinct from "not fetched": this record WAS fetched via getHostedZone
        // and the API returned no delegation set. A private zone legitimately has
        // none, so this is a state, not a failure.
        return <Text size={'sm'} c={'dimmed'} fs={'italic'}>No delegation set returned</Text>;
    }

    return (
        <>
            {nameServers.map(ns => (
                <Text key={ns} size={'xs'} ff={'monospace'}>{ns}</Text>
            ))}
        </>
    );
};

export const Profile = ({record}: { record: HostedZone }) => {

    const properties = [
        {
            label: 'Name',
            value: record.name,
            span: 12,
        },
        {
            label: 'Zone ID',
            value: <Text size={'xs'} ff={'monospace'}>{record.id}</Text>,
            span: 12,
        },
        {
            label: 'Visibility',
            value: typeof record.privateZone === 'boolean'
                ? (
                    <Badge variant={'light'} color={record.privateZone ? 'orange' : 'blue'}>
                        {record.privateZone ? 'Private' : 'Public'}
                    </Badge>
                )
                : null,
            span: 12,
        },
        {
            label: 'Record Sets',
            value: typeof record.recordSetCount === 'number'
                ? record.recordSetCount.toString()
                : null,
            span: 12,
        },
        {
            label: 'Account',
            value: <Text size={'xs'} ff={'monospace'}>{record.accountId}</Text>,
            span: 12,
        },
        {
            label: 'Comment',
            value: record.comment ?? null,
            span: 12,
        },
        {
            label: 'Name Servers',
            value: <NameServers nameServers={record.nameServers}/>,
            span: 12,
        },
        {
            label: 'Caller Reference',
            value: record.callerReference
                ? <Text size={'xs'} ff={'monospace'}>{record.callerReference}</Text>
                : null,
            span: 12,
        },
    ];

    return (
        <PlatformPropertyCard properties={properties}/>
    );
};
